@use "@fukuri-admins/ui/layout" as *;

.buttonContainer {
  display: flex;
  justify-content: flex-end;
  margin-bottom: spacing("16");
}

.tableWrapper {
  margin-bottom: spacing("16");
}

.deleteItem {
  color: text("Red");
}
